<template>
  <div>
    <apexchart
      ref="apexChart"
      type="rangeBar"
      :options="options"
      :series="series"
      :height="height"
      @dataPointSelection="handleClick"
    />
  </div>
</template>

<script>
export default {
  name: 'ApexTimelineCharts',
  props: {
    series: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },

  computed: {
    height () {
      if (this.options.chart != null && this.options.chart.height != null) {
        return this.options.chart.height
      } else {
        return 'auto'
      }
    },
  },
  watch: {
    options: {
      deep:true,
      handler(newValue, oldValue){
        if(newValue.toggleSelection != null && newValue.toggleSelection !== oldValue.toggleSelection) {
          this.toggleSelection()
        }
      }
    }
  },
  methods: {
    handleClick (event, chartContext, config) {
      // emit a changed selection event
      const selectedPoints = config.selectedDataPoints[0]
      const selectedData = selectedPoints.map(index => this.series[0].data[index])
      this.$emit('selection-changed', selectedData)

      // notify what point was clicked
      if (selectedPoints.length >= 1) {
        const value = this.series[config.seriesIndex].data[config.dataPointIndex]
        this.$emit('point-clicked', value)
      }
    },
    toggleSelection(){
      let chartDiv = this.$refs.apexChart
      Object.values(chartDiv.chart.w.globals.selectedDataPoints[0]).forEach((val) => {
        chartDiv.toggleDataPointSelection(0, val)
      })

      }
    }
}
</script>

<style scoped>

</style>
